import * as Yup from 'yup';
import { useFormik } from 'formik';

import { requiredMsg } from 'lib/constants/messages';

const PracticeMainDetailsSchema = Yup.object().shape({
  practiceName: Yup.string().required(requiredMsg('Practice name')),
  taxonomy: Yup.string().required(requiredMsg('Taxonomy'))
});

export default function usePracticeMainDetialsFormik(mainDetails = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      practiceName: mainDetails?.practiceName ?? '',
      dbaName: mainDetails?.dbaName ?? '',
      taxId: mainDetails?.taxId ?? '',
      taxIdType: mainDetails?.taxIdType ?? '',
      taxonomy: mainDetails?.taxonomy ?? '',
      practiceKind: mainDetails?.practiceKind ?? '',
      practiceStatus: mainDetails?.practiceStatus ?? ''
    },
    enableReinitialize: true,
    validationSchema: PracticeMainDetailsSchema,
    onSubmit
  });

  return formik;
}
